<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'name_of_collector')">
              <a-select style='width: 100%' v-model='queryParam.userId' optionFilterProp="children" showSearch
                allowClear>
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'grouping')">
              <a-select style='width: 100%' v-model="queryParam.groupId">
                <a-select-option v-for="item in groupList" :key="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'collection_stage')">
              <a-select default-value="" style='width: 100%' v-model="queryParam.normalConfigId">
                <a-select-option v-for="item in normalConfigList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t(I18N_KEY + 'repaymentTime')">
              <a-range-picker style='width: 100%' v-model="queryParam.updateTime" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>



        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
              }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table ref='table' rowKey='id' size='middle' :columns='columns' :dataSource='dataSource' :pagination='false'
        :loading='loading' bordered>
      </a-table>
      <!-- <div style='margin-top: 15px; text-align: right;'>
        <v-pagination v-if='total' :page-num='form.pageNum' :page-size='form.pageSize' :total='total'
          @change='handleTableChange' />
      </div> -->
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getPartRepatmentData } from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import OrderDetail from '@/views/webpublic/order/OrderDetail.vue'
import vModal from '@/views/webpublic/modules/Modal.vue'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getCollectorName } from '@/webpublicapi/collection'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = 'platformCollection.';

export default {
  name: 'AllApprovalTask',
  components: {
    vModal, OrderDetail,
    Dict,
    DictSelect
  },
  data() {
    return {
      CollectorNameList: [],
      paramsVal: {},
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      groupList: [],
      normalConfigList: [],
      queryParam: {
        userId: null,
        groupId: null,
        normalConfigId: null,
        updateTime: [moment().startOf('day'), moment().endOf('day')]
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'id_of_collector'),
          align: 'center',
          dataIndex: 'userId'
        },
        {
          title: this.$t(I18N_KEY + 'name_of_collector'),
          align: 'center',
          dataIndex: 'userName'
        },
        {
          title: this.$t(I18N_KEY + 'group_name'),
          align: 'center',
          dataIndex: 'groupName'
        },
        {
          title: this.$t(I18N_KEY + 'collection_stage'),
          align: 'center',
          dataIndex: 'configName'
        },
        {
          title: this.$t(I18N_KEY + 'succed_order_number'),
          align: 'center',
          dataIndex: 'recoveryNum'
        },
        {
          title: this.$t(I18N_KEY + 'part_repatment_num'),
          align: 'center',
          dataIndex: 'partRepatmentNum'
        },
        {
          title: this.$t(I18N_KEY + 'recovery_amount'),
          align: 'center',
          dataIndex: 'recoveryAmount'
        },
        {
          title: this.$t(I18N_KEY + 'repayment_amount'),
          align: 'center',
          dataIndex: 'partRepatmentAmount'
        }
      ]
    }
  },
  created() {
    getSysGroup().then(res => {
      if (res.data != null && res.data.length > 0) {
        this.groupList.push({
          'groupName': '全部',
          'id': '',
          'value': null
        });
        res.data.forEach(item => {
          this.groupList.push(item)
        })
      } else {
        this.groupList = [];
      }
    });
    getAllNormalConfig().then(res => {
      if (res.data != null && res.data.length > 0) {
        this.normalConfigList.push({
          'name': '全部',
          'id': '',
          'value': null
        });
        res.data.forEach(item => {
          this.normalConfigList.push(item)
        })
      } else {
        this.normalConfigList = [];
      }
    });
    getCollectorName().then(res => {
      console.log('res-->', res.data)
      let keys = Object.keys(res.data)
      for (const key of keys) {
        this.CollectorNameList.push({
          key: key,// s1test1
          value: res.data[key]
        })
      }
    });
    this.loadData(1);
  },
  methods: {

    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      var params = this.getQueryParams();
      if (params == null) {

      } else {
        this.loading = true
        getPartRepatmentData(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('res------->', res)
            this.dataSource = res.data.list
            this.total = res.data.total
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { updateTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        updateStartTime: (updateTime && updateTime.length) ? this.transformTime(updateTime[0]) : undefined,
        updateEndTime: (updateTime && updateTime.length) ? this.transformTime(updateTime[1]) : undefined
      }
      delete data.updateTime;
      this.paramsVal = {
        ...data
      }
      //分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

      async downLoadData() {
      var params = this.getQueryParams()// 查询条件
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/collectionTask/exportPartRepatmentData`,
          params,
          "催收绩效（日回款）.xlsx"
        );
        
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally{
        this.loading = false
      }
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.updateTime = [moment().startOf('day'), moment().endOf('day')];
      that.queryParam.userId = null;
      that.queryParam.groupId = null;
      that.queryParam.normalConfigId = null;
      that.loadData(this.form.pageNum)
    },
    onChangeOne(value) {
      console.log(value);
      getSysGroup({ "departmentId": value }).then(res => {
        this.groupList = res.data || [];
        this.queryParam.groupId = "";
      });
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .ant-modal {
  width: 600px !important;
}
</style>
